import httpService from "./http.service"

const clientService = {
  getClients: async ({
    limit = 50,
    offset = 0,
    signal,
    withTotal = false,
    qId,
    qName,
    qPhone,
    qBirthdate,
    birthdateFrom,
    birthdateTo,
    qLastRecordId,
    qLastRecordDate,
    lastRecordDateFrom,
    lastRecordDateTo,
    qLastRecordStatus,
    qTotalRecords,
    qLastService,
    sort,
    sortDir,
  } = {}) => {
    const params = { limit, offset }
    if (withTotal) params.with_total = 1
    if (qId) params.q_id = qId
    if (qName) params.q_name = qName
    if (qPhone) params.q_phone = qPhone
    if (qBirthdate) params.q_birthdate = qBirthdate
    if (birthdateFrom) params.birthdate_from = birthdateFrom
    if (birthdateTo) params.birthdate_to = birthdateTo
    if (qLastRecordId) params.q_last_record_id = qLastRecordId
    if (qLastRecordDate) params.q_last_record_date = qLastRecordDate
    if (lastRecordDateFrom) params.last_record_date_from = lastRecordDateFrom
    if (lastRecordDateTo) params.last_record_date_to = lastRecordDateTo
    if (qLastRecordStatus) params.q_last_record_status = qLastRecordStatus
    if (qTotalRecords) params.q_total_records = qTotalRecords
    if (qLastService) params.q_last_service = qLastService
    if (sort) params.sort = sort
    if (sortDir) params.sort_dir = sortDir
    const { data } = await httpService.get("api/clients/", {
      params,
      signal,
    })
    return data
  },
  getClientById: async (clientId) => {
    const { data } = await httpService.get("api/clients/client/" + clientId)
    return data
  },
  getClientsHistoryById: async (clientId) => {
    const { data } = await httpService.get("api/clients/client/history/" + clientId)
    return data
  },
  getClientByPhone: async (clientPhone, options = {}) => {
    const { data } = await httpService.get(
      "api/clients/client/phone/" + clientPhone,
      { signal: options.signal }
    )
    return data
  },
  getClientByTelegram: async (clientTelegram, options = {}) => {
    const { data } = await httpService.get(
      "api/clients/client/telegram/" + clientTelegram,
      { signal: options.signal }
    )
    return data
  },
  getClientByInstagram: async (clientInstagram, options = {}) => {
    const { data } = await httpService.get(
      "api/clients/client/instagram/" + clientInstagram,
      { signal: options.signal }
    )
    return data
  },
  getCurrentClient: async (clientId) => {
    const { data } = await httpService.get("api/clients/client/" + clientId)
    return data
  },
  UpdateCurrentClient: async (data) => {
    const { updatedClient } = await httpService.patch(
      "api/clients/client/" + data.clientId,
      data
    )
    return updatedClient
  },
  UploadClientImage: async (clientId, formData) => {
    await httpService.patch("api/clients/image/" + clientId, formData)
  },
  createClient: async (payload) => {
    const { data } = await httpService.post("api/clients/", payload)
    return data
  },
  updateClient: async (clientId, payload) => {
    await httpService.patch(`api/clients/client/${clientId}/`, payload)
  },
  deleteClient: async (clientId) => {
    const { data } = await httpService.delete(`api/clients/client/${clientId}/`)
    return data
  },
  deleteClientsBulk: async (ids) => {
    const { data } = await httpService.post("api/clients/bulk-delete/", { ids })
    return data
  },
}

export default clientService
